import { ActionIcon } from "@mantine/core";
import { IconHistory } from "@tabler/icons-react";
import { type ReactNode } from "react";

import { useTheme } from "../../../../../../hooks";
import { useDispatch } from "../../../../../../redux/hooks";
import { setModalProps } from "../../../../../../redux/slices/medicalHistorySlice";
import {
  StyledMedicalContent,
  StyledMedicalSection,
  StyledMedicalSectionHeader,
} from "../MedicalHistory.styled";

interface Props {
  children: ReactNode | ReactNode[];
  name: string;
  dataKey?: string;
  disabled?: boolean;
}

const MedicalSectionWrapper = ({
  name,
  children,
  dataKey,
  disabled,
}: Props) => {
  const dispatch = useDispatch();
  const theme = useTheme() as any;
  const handleViewHistory = () => {
    if (!dataKey || disabled) return;
    dispatch(
      setModalProps({
        section: dataKey,
      }),
    );
  };

  return (
    <StyledMedicalSection>
      <StyledMedicalContent style={{ alignItems: "center" }}>
        <StyledMedicalSectionHeader>{name}</StyledMedicalSectionHeader>
        {dataKey && !disabled && (
          <ActionIcon onClick={handleViewHistory}>
            <IconHistory />
          </ActionIcon>
        )}
      </StyledMedicalContent>
      <div style={{ marginLeft: "20px" }}> {children}</div>
    </StyledMedicalSection>
  );
};
export default MedicalSectionWrapper;
